import { render } from "./BadgesWithIcons.vue?vue&type=template&id=449f5275&ts=true"
import script from "./BadgesWithIcons.vue?vue&type=script&lang=ts"
export * from "./BadgesWithIcons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__